import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Paper } from "@mui/material";
import Titlebar from "../../TitleBar";
import { Pagination, SearchTable, TableBody2, TableBody3, TableHeader } from ".";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import {
	applyFilter,
	emptyRows,
	getComparator,
	extractDate,
} from "../../../Utils/table";
import { StudenMenu, Zones } from "../../TitleList";
import {
	selectStudents,
	selectZones,
} from "../../Selectors/Master/OutwardSelectors";
import { fetchStudentData, fetchZoneData } from "../../../Store/PHPSlice/zone";
import axios from "axios";
const baseUrl = process.env.REACT_APP_BASE_URL;

const StudentReg = () => {
	const userdata = JSON.parse(sessionStorage.getItem("user"));
	const dispatch = useDispatch();
	const getItems = useSelector(selectStudents);
	// const [getItems, setGetItems] = useState([]);
	const [order, setOrder] = useState("asc");
	const [orderBy, setOrderBy] = useState("empId");
	const [selected, setSelected] = useState([]);
	const [filterName, setFilterName] = useState("null");
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [currentPage, setCurrentPage] = useState(1);
	const [recordsPerPage, setRecordsPerPage] = useState(10);
	const [searchQuery, setSearchQuery] = useState("");
	const [firstIndex, setFirstIndex] = useState(0);
	const [lastIndex, setLastIndex] = useState(0);

	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
	const [searchTerm, setSearchTerm] = useState("");

	useEffect(() => {

		const fetchStudentsData2 = async () => {
			const response = await axios.get(
				`${baseUrl}?apicall=getWStudentData`
			);
			// console.log(response,'res222222222');
			// setGetItems(response.data);
		};
		fetchStudentsData2();
		if (userdata?.role !== "1") {
			dispatch(fetchStudentData({ userId: userdata?.ID }));
		} else {
			dispatch(fetchStudentData());
		}
	}, [dispatch]);

	if (!getItems) {
		return <h1>Loading...</h1>;
	}

	// console.log(getItems);


	const compData = Array.isArray(getItems.data)
		? getItems.data.map((item, index) => ({
			srNo: item.ID,
			zoneNm: item.zoneNm,
			schoolNm: item.schoolNm,
			studNm: item.studNm,
			age: item.age,
			std: item.std,
			div: item.div,
			ph: item.ph,
			serialNumber: index + 1,
		}))
		: [];

	const handleSort = (event, id) => {
		const isAsc = orderBy === id && order === "asc";
		if (id !== "") {
			setOrder(isAsc ? "desc" : "asc");
			setOrderBy(id);
		}
	};
	const handleSelectAllClick = (event) => {
		if (event.target.checked) {
			const newSelecteds = compData.map((n) => n.name);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	};

	const handleClick = (event, name) => {
		const selectedIndex = selected.indexOf(name);
		let newSelected = [];
		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, name);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1)
			);
		}
		setSelected(newSelected);
	};

	const handleChangeCPage = (n) => {
		setCurrentPage(n);
	};
	const handlePrevPage = () => {
		if (currentPage !== firstIndex) {
			setCurrentPage(currentPage - 1);
		}
	};

	const handleNextpage = () => {
		if (currentPage !== lastIndex) {
			setCurrentPage(currentPage + 1);
		}
	};

	const handleRecordsPerPageChange = (event) => {
		setRecordsPerPage(parseInt(event.target.value, 10)); // Parse selected value to integer
		setCurrentPage(0); // Reset current page when records per page changes
	};

	const totalCount = compData.length;
	const npages = Math.ceil(totalCount / recordsPerPage);
	const numbers = Array.from({ length: npages }, (_, i) => i + 1);
	const renderPaginationButtons = () => {
		let start = Math.max(0, currentPage - 5);
		let end = Math.min(npages, start + 9);

		if (end - start < 9) {
			start = Math.max(1, end - 9);
		}

		return numbers.slice(start - 1, end).map((n) => (
			<button
				key={n}
				className={`page-link ${currentPage === n - 1 ? "active" : ""}`}
				onClick={() => handleChangeCPage(n - 1)}
			>
				{n}
			</button>
		));
	};

	const handleFilterByName = (event) => {
		setPage(0);
		let value = event.target.value.trim();
		setFilterName(event.target.value);
	};
	// const dataFiltered = applyFilter({
	//     inputData: compData,
	//     comparator: getComparator(order, orderBy),

	// });
	// const notFound = !dataFiltered.length;

	const handleSearchChange = (event) => {
		setSearchTerm(event.target.value);
		setCurrentPage(1); // Reset to first page on search
	};

	const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
		item?.studNm?.toLowerCase().includes(searchTerm.toLowerCase())
	);


	const dataFiltered = applyFilter({
		inputData: filteredData,
		comparator: getComparator(order, orderBy),
	});

	const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
	const displayedData = dataFiltered.slice(
		(currentPage - 1) * itemsPerPage,
		currentPage * itemsPerPage
	);

	const pageNumbers = Array.from(
		{ length: totalPages },
		(_, index) => index + 1
	);
	const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

	const handleNextPageRange = () => {
		setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
	};

	const handlePreviousPageRange = () => {
		setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
	};

	const handlePageChange = (page) => {
		setCurrentPage(page);
	};

	const handleItemsPerPageChange = (event) => {
		setItemsPerPage(Number(event.target.value));
		setCurrentPage(1); // Reset to first page on change
	};
	// console.log(displayedData);

	return (
		<>
			<Titlebar data={StudenMenu} />

			<div style={{ margin: "1% 0.5%" }}>
				<h2>Student Register</h2>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Paper style={{ padding: "3vh", margin: "0" }}>
							<SearchTable
								handleItemsPerPageChange={
									handleItemsPerPageChange
								}
								searchTerm={searchTerm}
								handleSearchChange={handleSearchChange}
								totalItems={filteredData?.length}
							/>


							<TableContainer style={{ marginTop: '2%', border: '1px solid #ccc' }}>
								<Table>
									<TableHeader
										headCells={[
											{ id: "srNo", label: "Sr.No" },
											{
												id: "zoneNm",
												label: "Zone Name",
											},
											{
												id: "schoolNm",
												label: "School Name",
											},
											{
												id: "studNm",
												label: "Student Name",
											},
											{ id: "age", label: "Age" },
											{ id: "std", label: "Standard" },
											{ id: "div", label: "Division" },
											{ id: "ph", label: "Contact" },
											{ id: "edit", label: "Edit" },
											{ id: "delete", label: "Delete" },
										]}

										order={order}
										orderBy={orderBy}
										onRequestSort={handleSort}
										numSelected={selected.length}
										rowCount={compData.length}
										onSelectAllClick={handleSelectAllClick}
									/>
									<tbody>
										{displayedData?.map((row) => (
											<TableBody3
												key={row.srNo}
												id={row.srNo}
												zoneNm={row.zoneNm}
												schoolNm={row.schoolNm}
												studNm={row.studNm}
												age={row.age}
												std={row.std}
												div={row.div}
												ph={row.ph}
												serialNumber={row.serialNumber}
												//selected={selected.indexOf(row.srNo) !== -1}
												selected={selected.includes(
													row.srNo
												)}
												handleClick={(event) =>
													handleClick(event, row.srNo)
												}
											/>
										))}
									</tbody>
								</Table>
							</TableContainer>

							<Pagination
								currentPage={currentPage}
								handlePageChange={handlePageChange}
								handlePreviousPageRange={
									handlePreviousPageRange
								}
								visiblePageNumbers={visiblePageNumbers}
								pageNumber={pageNumbers}
								pageRange={pageRange}
								totalPages={totalPages}
								handleNextPageRange={handleNextPageRange}
							/>
						</Paper>
					</Grid>
				</Grid>
			</div>
		</>
	);
};

export default StudentReg;
